import React, {memo, useMemo} from "react"
import {Bar} from "react-chartjs-2"
import {useHistory} from "react-router-dom"
import {onClickHandler} from "../../../utils/onclick"
import {barOptions} from "../settings/options"
import { useSelector } from "react-redux"
import { useLocalization } from "../../../hooks/localization"

type Props = {
    amountStatus: (order: number) => void
    label: string
    data: object
    page: number
}
export const BarChart = memo(function BarChart({label, amountStatus, data, page}: Props) {
    const history = useHistory()
    const {t} = useLocalization()
    const energyControlList = useSelector(state => state.control.energyState)

     const amountType = useMemo(() => {
         switch (energyControlList.currency_unit) {
             case "try":
                 return "TRY"
             case "usd":
                 return "USD"
             case "eur":
                 return "EUR"
             case "gbp":
                 return "GBP"
         }
     }, [energyControlList])
    return (
        <div className="energy-box">
            <span>
                <span>
                    {t("energy_page.amount_chart")} ({amountType})
                </span>
                <span>
                    <button
                        {...onClickHandler(() => amountStatus(1))}
                        className={`${label === "hour" ? "energy-active-button" : ""}`}
                    >
                        {t("energy_page.hour")}
                    </button>
                    <button
                        {...onClickHandler(() => amountStatus(2))}
                        className={`${label === "day" ? "energy-active-button" : ""}`}
                    >
                        {t("energy_page.day")}
                    </button>
                    <button
                        {...onClickHandler(() => amountStatus(3))}
                        className={`${label === "month" ? "energy-active-button" : ""}`}
                    >
                        {t("energy_page.month")}
                    </button>
                </span>
            </span>
            <div
                className="energy-page"
                style={{height: "180px"}}
                onDoubleClick={() => history.push(`/energy/${page}`)}
            >
                {/* @ts-ignore */}
                <Bar data={data} options={barOptions} />
            </div>
        </div>
    )
})
